<style scoped>
</style>

<template>
	<v-expansion-panel>
		<v-expansion-panel-header class="blue--text">
			Jobs
		</v-expansion-panel-header>
		<v-expansion-panel-content>
			<v-job-results
				
				@click_job="job => open_job(job.id)"
				ref="job_search" 
			/>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
import job_results from "@/components/jobs/search_results";
export default {
	components: {
		'v-job-results': job_results,
	},
	props: {
		is_expanded: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			abook_id: 0,
			is_loaded: false,
		}
	},
	methods: {
		load(abook_id) {
			this.abook_id = abook_id;
			if (this.is_expanded) {
				this.do_search()
			} else {
				this.is_loaded = false;
			}
		},
		do_search() {
			this.is_loaded = true;

			this.$refs.job_search.perform_search({
				from_code: '',
				to_code: '',
				short: '',
				job_types: '',
				statusses: '',
				status_groups: [ 0, 1, 2 ],
				client: this.abook_id,
				invoice_from: null,
				invoice_to: null
			});
		}
	},
	watch: {
		'is_expanded': function(new_value) {
			if (new_value && !this.is_loaded) {
				this.do_search();
			}
		}
	}
}
</script>
